import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { motion, AnimatePresence } from "framer-motion";

import { makeStyles } from "@material-ui/core/styles";

import {
  toggleReviewFilterDrawer,
  toggleReviewHeatmap,
  setView,
  setReviewHeatmapType,
} from "../../actions";

// MUI Components
import Typography from "@material-ui/core/Typography";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Drawer from "@material-ui/core/Drawer";
import Grid from "@material-ui/core/Grid";
import Switch from "@material-ui/core/Switch";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import GridList from "@material-ui/core/GridList";
import GridListTile from "@material-ui/core/GridListTile";
import GridListTileBar from "@material-ui/core/GridListTileBar";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
//Icons
import FilterListIcon from "@material-ui/icons/FilterList";

import SimpleBodyMap from "./SimpleBodyMap";
import Header from "../Header/Header";
import LocationPlot from "./LocationPlot";
import SnackbarInfo from "../Shared/Snackbar";
import ColorScale from "../Shared/ColorScale";
import { customTheme } from "../../constants/customTheme";
import { colors } from "../../constants/colors";
import { heatmapTmodeType, heatmapEmodeType } from "../../constants/constants";
const useStyles = makeStyles({
  root: {
    flex: "1 1 auto",
    overflow: "hidden",
    backgroundColor: (props) =>
      props.theme === "light"
        ? colors[props.theme].background
        : colors[props.theme].bkg1,
  },
  displayRoot: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flex: "1 0 0",
    padding: "20px",
    overflow: "hidden",
  },
  main: {
    flex: "1 1 auto",
    overflow: "hidden",
  },
  gridListMap: (props) => ({
    width: "90%",
    height: "100%",
    marginRight: "45px",
    overflowX: "hidden",
    overflowY: "auto",
    ...customTheme(props.theme).customScrollBar,
  }),
  gridTileMap: {
    height: "100%",
    maxHeight: "500px",
    alignContent: "center",
    "& .MuiGridListTile-tile": {
      alignItems: "center",
      display: "flex",
      justifyContent: "center",
    },
  },
  gridTileBar: {
    height: "48px",
    marginLeft: "10px",
    marginRight: "10px",
    backgroundColor: "rgba(0,0,0,0.2)",
  },
  gridListGraph: (props) => ({
    width: "100%",
    height: "100%",
    overflowX: "hidden",
    overflowY: "auto",
    ...customTheme(props.theme).customScrollBar,
  }),
  gridTileGraph: {
    height: "100%",
    maxHeight: "500px",
    marginTop: "10px",
    marginBottom: "10px",
  },

  colorScaleWrapper: {
    position: "absolute",
    height: "40%",
    right: "29px",
    top: "30%",
    transition: "right 0.3s ease",
  },
  drawerGrid: {
    display: "flex",
    margin: "10px",
    flex: "1 0 0",
  },
  drawer: {
    borderBottomRightRadius: "20px",
    borderBottomLeftRadius: "20px",
    "& .MuiDrawer-paper": {
      overflowY: "visible",
      maxHeight: "70%",
    },
  },
  drawLeftColumn: {
    alignContent: "center",
    width: "40%",
  },
  drawRightColumn: {
    alignContent: "center",
    width: "60%",
  },
  filterButton: {
    alignSelf: "flex-end",
    padding: "5px 10px 0px 0px",
  },
  comparisonSelect: {
    width: "65%",
  },
  fromGroupTitle: {
    marginLeft: "10px",
  },
  listItem: {
    padding: "0px",
  },
  formControl: {
    width: "150px",
    maxHeight: "-webkit-fill-available",
  },
  studiesFormControl: {
    maxHeight: "-webkit-fill-available",
  },
  studiesList: (props) => ({
    width: "auto",
    overflowY: "auto",
    ...customTheme(props.theme).customScrollBar,
  }),
  switchHeatMap: {
    marginLeft: "10px",
    alignSelf: "flex-start",
  },
  mapList: (props) => ({
    width: "auto",
    overflowY: "auto",
    ...customTheme(props.theme).customScrollBar,
  }),
  mapFilter: {
    display: "flex",
    width: "65%",
    marginTop: "20px",
  },
  heatmapDiv: {
    display: "flex",
    flexDirection: "column",
  },
  heatmapTypeItem: {
    paddingLeft: "20px",
    "& .MuiFormControlLabel-label": {
      fontSize: "0.875rem",
    },
  },
});

const Review = (props) => {
  const classes = useStyles(props);

  const initialStudies = () => {
    let studies = {};

    Object.keys(props.studies).forEach((id) => {
      if (
        props.studies[id].protocol.maps[Object.keys(props.allMap)[0]] !==
        undefined
      ) {
        studies[id] = true;
      } else {
        studies[id] = false;
      }
    });
    return studies;
  };

  const [state, setState] = React.useState({
    comparison: "MAP",
    studies: initialStudies(),
    selectedMap: Object.keys(props.allMap)[0],
    colorScaleValue: null,
    visibleSeries: null,
  });

  const handleChangeComparisonView = (value) => {
    if (value === "MAP") {
      let newStudies = mapCheck(Object.keys(props.allMap)[0]);
      setState({
        ...state,
        studies: newStudies,
        selectedMap: Object.keys(props.allMap)[0],
        comparison: value,
        visibleSeries: null,
      });
    } else {
      setState({
        ...state,
        comparison: value,
      });
    }
  };

  const handleMapSelect = (mapId) => {
    let newStudies = mapCheck(mapId);
    setState({ ...state, studies: newStudies, selectedMap: mapId });
  };

  const mapCheck = (mapId) => {
    let newStudies = {};
    for (let study in props.studies) {
      if (Object.keys(props.studies[study].protocol.maps).includes(mapId)) {
        newStudies = { ...newStudies, [study]: true };
      } else {
        newStudies = { ...newStudies, [study]: false };
      }
    }
    return newStudies;
  };

  const setSeriesVisibility = (locationId) => {
    let newStudies = {};
    Object.keys(state.studies).forEach((studyId) => {
      if (props.studies[studyId].locations.allIds.includes(locationId)) {
        newStudies[studyId] = true;
      } else {
        newStudies[studyId] = false;
      }
    });
    setState({
      ...state,
      studies: newStudies,
      comparison: "GRAPH",
      visibleSeries: locationId,
    });
  };

  const handleStudySelect = (studyId) => {
    if (state.comparison === "MAP") {
      if (
        props.studies[studyId].protocol.maps[state.selectedMap] !== undefined
      ) {
        setState({
          ...state,
          studies: {
            ...state.studies,
            [studyId]: !state.studies[studyId],
          },
        });
      } else {
        handleMapSelect(Object.keys(props.studies[studyId].protocol.maps)[0]);
      }
    } else {
      setState({
        ...state,
        studies: {
          ...state.studies,
          [studyId]: !state.studies[studyId],
        },
      });
    }
  };

  return (
    <Grid container className={classes.root} direction="column" wrap="nowrap">
      {/* HEADER */}
      <Header
      // eventSource={props.eventSource}
      />

      <IconButton
        className={classes.filterButton}
        onClick={() => props.toggleReviewFilterDrawer()}
      >
        <FilterListIcon />
      </IconButton>

      {/* COLOR SCALE */}
      <AnimatePresence>
        {props.reviewHeatmap.status && state.comparison === "MAP" && (
          <motion.div
            className={classes.colorScaleWrapper}
            initial={{ x: 60 }}
            animate={{ x: 0 }}
            exit={{ x: 60 }}
          >
            <ColorScale
              heatmapType={props.reviewHeatmap}
              value={state.colorScaleValue}
            />
          </motion.div>
        )}
      </AnimatePresence>

      {/* APP */}
      <Grid container className={classes.main} wrap="nowrap">
        {state.comparison === "MAP" ? (
          <div className={classes.displayRoot}>
            <GridList
              cellHeight={"100%"}
              className={classes.gridListMap}
              cols={3}
            >
              {props.allStudyIds.map((id) => {
                if (state.studies[id]) {
                  return (
                    <GridListTile
                      className={classes.gridTileMap}
                      key={id}
                      cols={1}
                    >
                      <motion.div
                        whileHover={{ scale: 1.1 }}
                        style={{ height: "100%", maxHeight: "500px" }}
                      >
                        <SimpleBodyMap
                          id={id}
                          bodyMapId={state.selectedMap}
                          setSeriesVisibility={(id) => setSeriesVisibility(id)}
                          setColorScaleValue={(colorValue) =>
                            setState({
                              ...state,
                              colorScaleValue: colorValue,
                            })
                          }
                        />
                      </motion.div>
                      <GridListTileBar
                        className={classes.gridTileBar}
                        title={props.studies[id].studyInfo.protocolName}
                        subtitle={props.studies[id].studyInfo.studyDate}
                      />
                    </GridListTile>
                  );
                }
              })}
            </GridList>
          </div>
        ) : (
          <div className={classes.displayRoot}>
            <GridList
              cellHeight={"80%"}
              className={classes.gridListGraph}
              cols={1}
            >
              {Object.keys(props.studiesByProtocol).map((protocolId) => {
                let check = !props.studiesByProtocol[protocolId].every(
                  (studyId) => {
                    return !state.studies[studyId];
                  }
                );
                if (check) {
                  return (
                    <GridListTile
                      className={classes.gridTileGraph}
                      key={protocolId}
                      cols={1}
                    >
                      <LocationPlot
                        protocolId={protocolId}
                        studyToggle={state.studies}
                        seriesVisibility={state.visibleSeries}
                      />
                    </GridListTile>
                  );
                }
              })}
            </GridList>
          </div>
        )}
      </Grid>
      <SnackbarInfo />

      {/* FILTER DRAW */}
      <Drawer
        anchor="top"
        className={classes.drawer}
        open={props.filterDrawer}
        onClose={() => props.toggleReviewFilterDrawer()}
      >
        <Grid
          container
          className={classes.drawerGrid}
          direction="row"
          wrap="nowrap"
        >
          <Grid
            item
            container
            className={classes.drawLeftColumn}
            direction="column"
          >
            <FormControl className={classes.studiesFormControl}>
              <Typography className={classes.fromGroupTitle}>
                Studies:
              </Typography>
              <List className={classes.studiesList}>
                {props.allStudyIds.map((id) => {
                  return (
                    <ListItem className={classes.listItem} key={id}>
                      <ListItemIcon>
                        <Checkbox
                          color="primary"
                          onChange={(event) =>
                            handleStudySelect(event.target.value)
                          }
                          checked={state.studies[id]}
                          value={id}
                        />
                      </ListItemIcon>
                      <ListItemText
                        primary={props.studies[id].studyInfo.studyDate}
                        secondary={props.studies[id].studyInfo.protocolName}
                      />
                    </ListItem>
                  );
                })}
              </List>
            </FormControl>
          </Grid>

          <Divider orientation="vertical" flexItem />

          <Grid
            item
            container
            className={classes.drawRightColumn}
            direction="column"
          >
            <FormControl className={classes.comparisonSelect}>
              <Typography> Review Participant Data: </Typography>
              <Select
                className={classes.select}
                onChange={(event) =>
                  handleChangeComparisonView(event.target.value)
                }
                value={state.comparison}
              >
                <MenuItem value={"MAP"}>Map comparison</MenuItem>
                <MenuItem value={"GRAPH"}>Graphical comparison</MenuItem>
              </Select>
            </FormControl>
            {state.comparison === "MAP" && (
              <div className={classes.mapFilter}>
                <FormControl className={classes.formControl}>
                  <Typography className={classes.fromGroupTitle}>
                    Maps:
                  </Typography>
                  <List className={classes.mapList}>
                    {Object.keys(props.allMap).map((mapId) => {
                      return (
                        <ListItem className={classes.listItem} key={mapId}>
                          <ListItemIcon>
                            <Checkbox
                              color="primary"
                              onChange={(event) => {
                                handleMapSelect(event.target.value);
                              }}
                              checked={state.selectedMap === mapId}
                              value={mapId}
                            />
                          </ListItemIcon>
                          <ListItemText primary={props.allMap[mapId].name} />
                        </ListItem>
                      );
                    })}
                  </List>
                </FormControl>
                <div className={classes.heatmapDiv}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={props.reviewHeatmap.status}
                        onChange={() => props.toggleReviewHeatmap()}
                        color="primary"
                      />
                    }
                    label="Heat Map"
                    labelPlacement="start"
                    className={classes.switchHeatMap}
                  />

                  <RadioGroup
                    value={props.reviewHeatmap.type}
                    onChange={(event) =>
                      props.setReviewHeatmapType(event.target.value)
                    }
                  >
                    <FormControlLabel
                      value={heatmapEmodeType}
                      className={classes.heatmapTypeItem}
                      control={<Radio size="small" color="primary" />}
                      label="E-Mode"
                    />
                    <FormControlLabel
                      value={heatmapTmodeType}
                      className={classes.heatmapTypeItem}
                      control={<Radio size="small" color="primary" />}
                      label="T-Mode"
                    />
                  </RadioGroup>
                </div>
              </div>
            )}
          </Grid>
        </Grid>
      </Drawer>
    </Grid>
  );
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      toggleReviewFilterDrawer,
      toggleReviewHeatmap,
      setView,
      setReviewHeatmapType,
    },
    dispatch
  );
};

const mapStateToProps = (state) => {
  let allMap = {};
  Object.keys(state.availableParticipants.reviewStudies).forEach((study) => {
    Object.keys(
      state.availableParticipants.reviewStudies[study].protocol.maps
    ).forEach((map) => {
      if (allMap[map] === undefined) {
        allMap = {
          ...allMap,
          [map]: {
            name: state.availableParticipants.reviewStudies[study].protocol
              .maps[map].name,
          },
        };
      }
    });
  });

  let studiesByProtocol = {};
  Object.keys(state.availableParticipants.reviewStudies).forEach((study) => {
    let protocolId =
      state.availableParticipants.reviewStudies[study].studyInfo.protocolId;
    if (!Object.keys(studiesByProtocol).includes(protocolId)) {
      studiesByProtocol[protocolId] = [];
      studiesByProtocol[protocolId].push(study);
    } else {
      studiesByProtocol[protocolId].push(study);
    }
  });

  return {
    allStudyIds: Object.keys(state.availableParticipants.reviewStudies),
    studiesByProtocol: studiesByProtocol,
    studies: state.availableParticipants.reviewStudies,
    filterDrawer: state.utility.filterDrawer,
    reviewHeatmap: state.utility.reviewHeatmap,
    allMap: allMap,
    theme: state.utility.theme,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Review);
